










import { Component, Mixins } from 'vue-property-decorator';
import SidebarTypes from '@rogues/Sidebar/export';

@Component({
    components: {
        ...SidebarTypes,
    },
})

/**
 * @name Sidebar
 */
export default class Sidebar extends Mixins() {
    /**
     * Return name of type
     *
     * @returns {string}
     */
    get typeName(): string {
        return this.$attrs.type;
    }
}
